import { Box } from '@mui/material';
import React from 'react';
import OrderCardInfo from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/orders/order-info-card';
import OrderProductsList from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/orders/order-products-list';
import { ActiveOrder } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/order-assortment.type';

type Props = {
  order: ActiveOrder;
};

// Chile (M3) orders have no vessel or loading plant, so the order details panel is left out.
const ChileOrderRowBody: React.FC<Props> = ({ order }) => {
  return (
    <Box paddingBottom={4}>
      <Box display={'flex'} flexDirection={'column'} width={'100%'} padding={2} marginBottom={2}>
        <OrderProductsList orderLines={order.orderLines} />
      </Box>
      <OrderCardInfo order={order} />
    </Box>
  );
};

export default React.memo(ChileOrderRowBody);
